export default{

    //修改组件值
    alterStoreType(context,name){
        context.commit('storeType',name)
    },

    //修改组件值
    alterComponentType(context,name){
        context.commit('componentType',name)
    },

    //添加用户信息
    addProductId(context,id){
        context.commit('addProductId',id)
    },

    //修改组件值
    alterStoreOrderType(context,name){
        context.commit('alterStoreOrderType',name)
    },

    //修改订单号
    alterOrderId(context,id){
        context.commit('alterOrderId',id)
    },

    //修改订单详情地址
    alterOrderComponet(context,id){
        context.commit('alterOrderComponet',id)
    },

    

}


// WEBPACK FOOTER //
// ./src/vuex/store/action.js